import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import { get } from "lodash";
import { LanguageContext } from "components/language";
import { useContext } from "react";
import Currency from "components/Currency";
import { getNutirationText } from "utils/functions";

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon
        sx={{
          fontSize: "0.9rem",
          background: "rgba(244, 243, 248, 1)",
          transform: "rotate(90deg)",
          borderRadius: "5px",
        }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  flex: 1,
  padding: 0,
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
  ".MuiAccordionSummary-expandIconWrapper": {
    padding: "8px",
    backgroundColor: "rgba(244, 243, 248, 1)",
    borderRadius: "8px",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
  h6: {
    fontWeight: "700",
    fontSize: "16px",
    marginBottom: "10px",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  p: {
    fontWeight: "500",
    fontSize: "16px",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const AccordionRoom = ({ activeRate }) => {
  const [expanded, setExpanded] = React.useState("panel");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const getPrepaymentText = () => {
    if (!get(activeRate, "prepayment")) return t("WITHOUT_PREPAYMENT");
    const amount = get(activeRate, "prepaymentAmount", 0);
    switch (get(activeRate, "prepaymentStatus")) {
      case "FIX_PRICE":
        return (
          <>
            {t("FIXED_AMOUNT")} -
            <Currency code={get(activeRate, "currencyCode")} />
            {amount}
          </>
        );
      case "INTEREST_PREPAYMENT":
        return `${amount} % ${t("OF_TOTAL_AMOUNT")}`;
      case "FULL_PREPAYMENT":
        return t("FULL_PREPAYMENT");
      case "PER_DAY_PREPAYMENT":
        return `${t("THE_FIRST")} ${amount} ${t("DAYS_OF_STAY")}`;
      default:
        return t("WITHOUT_PREPAYMENT");
    }
  };

  const { t } = useContext(LanguageContext);
  return (
    <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" },
        }}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Box className="acordion-desc">
            <p>{t("TERMS_OF_STANDART_RATE")}</p>
          </Box>
        </AccordionSummary>
      </Box>
      <AccordionDetails>
        <Grid spacing={2} container>
          <Grid item xs={12} md={6}>
            <h6>{t("TARIFF_DESCRIPTION")}:</h6>
            <p>{get(activeRate, "description", "")}</p>
          </Grid>
          <Grid item xs={12} md={6}>
            <h6>{t("RESERVATION_CANCELLATION_CONDITIONS")}:</h6>
            <p>{get(activeRate, "cancellationPolicy", "")}</p>
          </Grid>
          <Grid item xs={12} md={6}>
            <h6>{t("PREPAYMENT")}</h6>
            <p>{getPrepaymentText()}</p>
          </Grid>
          <Grid item xs={12} md={6}>
            <h6>{t("FOOD")}:</h6>
            <p>{getNutirationText(activeRate, t)}</p>
          </Grid>
        </Grid>
        <Typography></Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionRoom;
